import CommentSolid from './CommentSolid'

export default CommentSolid
// eslint-disable-next-line import/export
export * from './CommentSolid'
